import { isNullOrUndefined } from '@cs/core/utils';
// Assuming `isNil` from FormatProviderService could be a shared utility.
// If not, keep using `isNullOrUndefined` for consistency with @cs/core/utils.
// const isNil = (v: any): v is null | undefined => v == null;

export enum FormatProviders {
	DotNet = 'dotNet',
}

export class FormatRegisteredItem {
	// Mark properties as readonly if they are not meant to change after construction.
	// This enhances immutability and code clarity.
	readonly type: string | null; // type can be null from constructor
	readonly formatString: string;
	readonly provider: FormatProviders;
	readonly parse: (value: any) => any; // Use `any` for value type consistency

	constructor(
		type: string | null, // Explicitly allow null for type in constructor signature
		formatString: string,
		parseMethod: (value: any) => any = (value) => value // Explicit type for parseMethod
	) {
		// Use the imported isNullOrUndefined for consistency with @cs/core/utils
		this.type = isNullOrUndefined(type) ? null : type.toLowerCase();
		this.formatString = formatString;
		this.parse = parseMethod;
		// Provider can be explicitly set in constructor if needed, or always defaults
		this.provider = FormatProviders.DotNet; // Default as per original logic
	}

	clone(formatString: string): FormatRegisteredItem {
		return new FormatRegisteredItem(this.type, formatString, this.parse);
	}
}
